import { useEffect } from "react";
import { BottomSheet } from "react-spring-bottom-sheet";
import "react-spring-bottom-sheet/dist/style.css";
import PlayItem from "./PlayPageComponent/PlayItem/PlayItem";

const CustomBottomSheet = ({
    newHudaList,
    isOpen,
    setOpenBottomSheet,
    setHudaIndex,
    hudaIndex,
    maxIndex,
    setMaxIndex,
    setStartTimer,
    repeatRef,
    setOnCountdownStart,
}) => {
    useEffect(() => {
        console.log(newHudaList);
    }, []);
    return (
        <div>
            <div
                style={{ width: "100%" }}
                onClick={() => {
                    console.log("CustomBottomSheet Clicked");
                }}
            >
                <BottomSheet
                    blocking={true}
                    open={isOpen}
                    snapPoints={({ minHeight, maxHeight }) => [
                        maxHeight * 0.9, //최대
                    ]}
                    onDismiss={() => {
                        setOpenBottomSheet(false);
                    }}
                >
                    {newHudaList.map((huda, index) => {
                        return (
                            <PlayItem
                                setOnCountdownStart={setOnCountdownStart}
                                repeatRef={repeatRef}
                                setStartTimer={setStartTimer}
                                maxIndex={maxIndex}
                                setMaxIndex={setMaxIndex}
                                newHudaList={newHudaList}
                                key={index}
                                huda={huda}
                                index={index}
                                hudaIndex={hudaIndex}
                                isSelected={index == hudaIndex}
                                setOpenBottomSheet={setOpenBottomSheet}
                                setHudaIndex={setHudaIndex}
                            ></PlayItem>
                        );
                    })}
                    {/* <PlayItem eHuda={newHudaList[0].eHuda} setOpenBottomSheet={setOpenBottomSheet}></PlayItem>
                    <PlayItem eHuda={newHudaList[1].eHuda} setOpenBottomSheet={setOpenBottomSheet}></PlayItem> */}
                </BottomSheet>
            </div>
        </div>
    );
};

export default CustomBottomSheet;
